import pick from 'lodash/pick';

import { createSelector } from 'reselect';
import { getNotificationEntities } from '../entities';

const getNotificationsState = (state) => state.notifications;

export const getAllUnreadNotifications = createSelector(
  [getNotificationsState, getNotificationEntities],
  (notificationsState, notifications) => {
    let { UNREAD, unreadCounter } = notificationsState;

    return {
      notificationIds: UNREAD.ids,
      notifications: pick(notifications, UNREAD.ids),
      loaded: UNREAD.loaded,
      unreadCounter,
    };
  },
);

export const getAlertNotifications = createSelector(
  [getNotificationsState, getNotificationEntities],
  (notificationsState, notifications) => {
    let { ALERT } = notificationsState;

    return {
      sortedIds: ALERT.ids,
      items: pick(notifications, ALERT.ids),
      loaded: ALERT.loaded,
    };
  },
);
